import React from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import CalculatorsStyles from './Calculators.styled';
import Link from '../Shared/Link';

const defaultChildren = (
  <>
    <h2>Calculators</h2>
    <p>Estimate your potential monthly payment</p>
  </>
);

const defaultColumnOne = (
  <>
    <Link to='/calculators/mortgage-calculator/'>Mortgage calculator</Link>
    <p>Estimate your monthly mortgage payment</p>
  </>
);

const defaultColumnTwo = (
  <>
    <Link to='/calculators/biweekly-extra-principal/'>
      Biweekly extra calculator
    </Link>
    <p>Get the most out of biweekly payments</p>
  </>
);

const Documents = ({
  children = defaultChildren,
  columnOne = defaultColumnOne,
  columnTwo = defaultColumnTwo,
  isAnimated = true,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <CalculatorsStyles
      ref={ref}
      className={`block-calculators ${isAnimated ? 'isAnimated' : ''} ${
        inView ? 'active' : ''
      }`}
    >
      <div className='inner'>
        <div className='content'>{children}</div>
        <div className='columns'>
          <div className='column'>{columnOne}</div>
          <div className='column'>{columnTwo}</div>
        </div>
      </div>
    </CalculatorsStyles>
  );
};

Documents.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  documents: PropTypes.arrayOf([PropTypes.string]),
  isAnimated: PropTypes.bool,
};

export default Documents;
